import React from 'react';
import { motion } from 'framer-motion';
import { X, PlayCircle, Share2 } from 'lucide-react';

interface VideoModalProps {
  title: string;
  videoUrl: string;
  duration: string;
  onClose: () => void;
}

export function VideoModal({ title, videoUrl, duration, onClose }: VideoModalProps) {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-background rounded-xl border border-border max-w-4xl w-full overflow-hidden flex flex-col"
      >
        {/* Header */}
        <div className="p-4 border-b border-border flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="relative">
              <PlayCircle className="w-6 h-6 text-primary" />
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            </div>
            <div>
              <h2 className="text-lg font-semibold">{title}</h2>
              <div className="text-sm text-muted-foreground">{duration}</div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Video Player */}
        <div className="aspect-video bg-black">
          <iframe
            src={videoUrl}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-border">
          <button className="theme-button w-full py-2 rounded-lg flex items-center justify-center gap-2">
            <Share2 className="w-4 h-4" />
            Share Video
          </button>
        </div>
      </motion.div>
    </div>
  );
}